import { forwardRef } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import "../../style/common/ConfirmModal.scss";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ConfirmModal(props) {
  const {
    onClose,
    open,
    cancelRequired = true,
    dialogConfirmationTitle = "Confirmation",
    dialogConfirmationMessage = "Are Your Sure ?",
    showTitle = true,
    width = "auto",
    height = "auto",
    onConfirm,
    ...other
  } = props;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
    if (onConfirm) {
      onConfirm(); // Call the onConfirm function if provided
    }
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: width,
          height: height,
          borderRadius: "10px",
        },
      }}
      maxWidth="md"
      TransitionComponent={Transition}
      open={open}
      {...other}
    >
      {showTitle && <DialogTitle>{dialogConfirmationTitle}</DialogTitle>}

      <DialogContent dividers>{dialogConfirmationMessage}</DialogContent>
      <DialogActions>
        {cancelRequired && (
          <div className="dialog-cancel">
            <Button autoFocus onClick={handleCancel}>
              NO
            </Button>
          </div>
        )}
        {cancelRequired && <div className="vline"></div>}
        <div className="dialog-confirm">
          <Button onClick={handleOk}>YES</Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

ConfirmModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ConfirmModal;
